import { tr as __tr, useLocale as __useLocale, direction as __direction, localizedField as __localizedField } from "../i18n/runtime";
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Facebook, Twitter, Instagram, Mail, Phone, MapPin } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
const Footer = () => {
  __useLocale();
  const {
    t,
    language
  } = useLanguage();
  const [contactInfo, setContactInfo] = useState(null);
  const servicesLinks = [{
    name: t('footer.hotelBooking'),
    href: '/#hotels'
  }, {
    name: t('footer.busBooking'),
    href: '/#buses'
  }, {
    name: t('footer.visaServices'),
    href: '/#visas'
  }, {
    name: t('footer.flightBooking'),
    href: '/#flights'
  }];
  const supportLinks = [{
    name: t('footer.faq'),
    href: '/#faq'
  }, {
    name: t('footer.contactUs'),
    href: '#contact'
  }, {
    name: t('footer.terms'),
    href: '/#terms'
  }, {
    name: t('footer.privacy'),
    href: '/#privacy'
  }];
  useEffect(() => {
    const fetchContactInfo = async () => {
      try {
        const res = await axios.get('/api/contact.php'); // عدل الرابط حسب الـ API عندك
        setContactInfo(res.data);
      } catch (error) {
        console.error('Error fetching contact info:', error);
      }
    };
    fetchContactInfo();
  }, []);
  const renderServicesLinks = () => servicesLinks.map((link, index) => <li key={index}>
        <a href={link.href} className="text-gray-400 hover:text-[#FF8C42] transition-colors duration-300">
          {__tr(__localizedField(link, "name"))}
        </a>
      </li>);
  const renderSupportLinks = () => supportLinks.map((link, index) => <li key={index}>
        <a href={link.href} className="text-gray-400 hover:text-[#FF8C42] transition-colors duration-300">
          {__tr(__localizedField(link, "name"))}
        </a>
      </li>);
  return <footer id="contact" className="bg-gray-900 text-white" dir={language === 'ar' ? 'rtl' : 'ltr'}>
      <div className="max-w-6xl mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand Column */}
          <div>
            <div className="flex items-center gap-2 mb-6">
              <span className="text-3xl font-bold">{__tr(t('brand'))}</span>
              <span className="text-[#FF8C42] text-2xl">✈</span>
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed">{__tr(t('footer.aboutDesc'))}</p>
            <div className="flex gap-3">
              <a href={contactInfo?.facebook || '#'} className="w-10 h-10 bg-gray-800 hover:bg-[#6B5B95] rounded-full flex items-center justify-center transition-colors duration-300">
                <Facebook className="w-5 h-5" />
              </a>
              <a href={contactInfo?.twitter || '#'} className="w-10 h-10 bg-gray-800 hover:bg-[#6B5B95] rounded-full flex items-center justify-center transition-colors duration-300">
                <Twitter className="w-5 h-5" />
              </a>
              <a href={contactInfo?.instagram || '#'} className="w-10 h-10 bg-gray-800 hover:bg-[#6B5B95] rounded-full flex items-center justify-center transition-colors duration-300">
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-6">{__tr(t('footer.services'))}</h4>
            <ul className="space-y-3">{__tr(renderServicesLinks())}</ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="text-lg font-bold mb-6">{__tr(t('footer.support'))}</h4>
            <ul className="space-y-3">{__tr(renderSupportLinks())}</ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-bold mb-6">{__tr(t('footer.contact'))}</h4>
            <ul className="space-y-4">
              <li className="flex items-center gap-3 text-gray-400">
                <div className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center">
                  <Mail className="w-5 h-5 text-[#FF8C42]" />
                </div>
                <span>{__tr(contactInfo?.company_email || 'info@rehlaty.com')}</span>
              </li>
              <li className="flex items-center gap-3 text-gray-400">
                <div className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center">
                  <Phone className="w-5 h-5 text-[#FF8C42]" />
                </div>
                <span dir={__direction()}>{__tr(contactInfo?.company_phone || '+967 123 456 789')}</span>
              </li>
              <li className="flex items-center gap-3 text-gray-400">
                <div className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center">
                  <MapPin className="w-5 h-5 text-[#FF8C42]" />
                </div>
                <span>
                  {__tr(language === 'ar' ? contactInfo?.company_address_ar || "عدن، اليمن" : contactInfo?.company_address_en || 'Aden, Yemen')}
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-6xl mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-500 text-sm">
              © 2025 {__tr(t('brand'))}. {__tr(t('footer.rights'))}.
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-gray-500 hover:text-white text-sm transition-colors">
                {__tr(t('footer.privacy'))}
              </a>
              <a href="#" className="text-gray-500 hover:text-white text-sm transition-colors">
                {__tr(t('footer.terms'))}
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;
